var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_7787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 2.77734C1.63285 2.77734 1.06762 3.01147 0.650874 3.42822C0.234126 3.84496 0 4.4102 0 4.99957L0 14.9996C0 15.5889 0.234126 16.1542 0.650874 16.5709C1.06762 16.9877 1.63285 17.2218 2.22222 17.2218H6.66667V2.77734H2.22222Z",
    fill: "#009A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.77734H13.3333V17.2218H6.66667V2.77734Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 2.77734H13.3333V17.2218H17.7778C18.3671 17.2218 18.9324 16.9877 19.3491 16.5709C19.7659 16.1542 20 15.5889 20 14.9996V4.99957C20 4.4102 19.7659 3.84496 19.3491 3.42822C18.9324 3.01147 18.3671 2.77734 17.7778 2.77734Z",
    fill: "#009A49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_7787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.262407d5f7cadeabd32773b4dcd990a6.svg";
export { ForwardRef as ReactComponent };